import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/auth/AuthProvider';
import { Layout, RrugeMbrojtur } from '@/components/Layout';
import { Ngarkim } from '@/components/ui';
import HyrjaFaqe from '@/pages/Hyrja';
import './index.css';

const Regjistrimi = lazy(() => import('@/pages/Regjistrimi'));
const NePritje = lazy(() => import('@/pages/NePritje'));
const Paneli = lazy(() => import('@/pages/Paneli'));
const Institucionet = lazy(() => import('@/pages/Institucionet'));
const Pajisjet = lazy(() => import('@/pages/Pajisjet'));
const PajisjaDetaje = lazy(() => import('@/pages/PajisjaDetaje'));
const InstitucioniDetaje = lazy(() => import('@/pages/InstitucioniDetaje'));
const ListaEAplikimeve = lazy(() => import('@/pages/Aplikimet').then((m) => ({ default: m.ListaEAplikimeve })));
const AplikimIRi = lazy(() => import('@/pages/Aplikimet').then((m) => ({ default: m.AplikimIRi })));
const AplikimiDetaje = lazy(() => import('@/pages/Aplikimet').then((m) => ({ default: m.AplikimiDetaje })));
const Sherbimet = lazy(() => import('@/pages/Sherbimet'));
const Perdoruesit = lazy(() => import('@/pages/Perdoruesit'));
const Konfigurimi = lazy(() => import('@/pages/Konfigurimi'));
const GjeneruesiICertifikates = lazy(() => import('@/pages/GjeneruesiICertifikates'));
const CertifikataOnline = lazy(() => import('@/pages/CertifikataOnline'));
const Mesazhet = lazy(() => import('@/pages/Mesazhet'));

const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } } });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<Ngarkim />}>
            <Routes>
              <Route path="/hyrje" element={<HyrjaFaqe />} />
              <Route path="/regjistrohu" element={<Regjistrimi />} />
              <Route path="/ne-pritje" element={<NePritje />} />
              <Route element={<RrugeMbrojtur rolet={['superadmin', 'staf', 'financa', 'klient']} />}>
                <Route element={<Layout />}>
                  <Route path="/paneli" element={<Paneli />} />
                  <Route path="/pajisje" element={<Pajisjet />} />
                  <Route path="/pajisje/:id" element={<PajisjaDetaje />} />
                  <Route path="/sherbimet" element={<Sherbimet />} />
                  {/* Faqja e importit u zëvendësua nga Shërbimet; importi bëhet me CLI-në (tools/import). */}
                  <Route path="/importi/*" element={<Navigate to="/sherbimet" replace />} />
                  {/* Lidhja e kodit QR të certifikatës; aksesi kufizohet nga rregullat e Firestore. */}
                  <Route path="/kontrolle/:id" element={<CertifikataOnline />} />
                  <Route path="/mesazhet" element={<Mesazhet />} />
                  <Route element={<RrugeMbrojtur rolet={['superadmin', 'staf']} />}>
                    <Route path="/pajisje/:id/certifikata" element={<GjeneruesiICertifikates />} />
                  </Route>
                  <Route element={<RrugeMbrojtur rolet={['superadmin', 'staf', 'financa']} />}>
                    <Route path="/institucione" element={<Institucionet />} />
                    <Route path="/institucione/:id" element={<InstitucioniDetaje />} />
                  </Route>
                  <Route element={<RrugeMbrojtur rolet={['klient']} />}>
                    <Route path="/institucioni-im" element={<InstitucioniDetaje />} />
                  </Route>
                  <Route element={<RrugeMbrojtur rolet={['superadmin', 'staf', 'klient']} />}>
                    <Route path="/aplikime" element={<ListaEAplikimeve />} />
                    <Route path="/aplikime/e-re" element={<AplikimIRi />} />
                    <Route path="/aplikime/:id" element={<AplikimiDetaje />} />
                  </Route>
                  <Route element={<RrugeMbrojtur rolet={['superadmin']} />}>
                    <Route path="/perdoruesit" element={<Perdoruesit />} />
                    <Route path="/konfigurimi" element={<Konfigurimi />} />
                  </Route>
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/paneli" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
